export default __webpack_public_path__ + "static/media/mb-cta-chevron-dark.e84df3a7.svg";